export default function VestaBadge({ className = "h-4 w-4" }) {
  return (
    <img
      src="/vesta-badge.png"
      alt="Vesta"
      className={`inline-block shrink-0 rounded-full object-contain align-[-0.15em] ${className}`}
      data-testid="vesta-badge"
    />
  );
}
